__turbopack_context__.v({
  "className": "quattrocento_33e7bb55-module__KfJiSa__className",
  "variable": "quattrocento_33e7bb55-module__KfJiSa__variable",
});
